import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, switchMap, throwError } from "rxjs";
import { CredentialService } from "src/app/modules/authentication/credential.service";

export const unauthorizedErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const credentialService = inject(CredentialService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        return throwError(() => error);
      }

      if (credentialService.isRefreshTokenRequest(request.url)) {
        credentialService.forceLogout();
        return throwError(() => error);
      }

      return credentialService.refreshAccessToken().pipe(
        switchMap(response => {
          credentialService.setAuthTokens(response.access, response.refresh);
          return next(
            request.clone({
              setHeaders: {
                Authorization: `Bearer ${response.access}`,
              },
            }),
          );
        }),
        catchError(() => {
          credentialService.forceLogout();
          return throwError(() => error);
        }),
      );
    }),
  );
};
